var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfBene3Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-0b1edd5b-6b2e-4ab7-afdf-8c9af1fd9f69",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#4a46ab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-1eefdf77-debd-4e4f-89b8-7feb2ce13ec3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-23c0dd28-da4a-4597-9d20-b4504f4039c3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.41,39.29c-2.23,0-4.04-1.81-4.04-4.04v-10.1h-12.12c-3.34,0-6.06,2.72-6.06,6.06v28.29c0,3.34,2.72,6.06,6.06,6.06h20.21c3.34,0,6.06-2.72,6.06-6.06v-20.21h-10.1ZM37.42,52.66c.31-.75,1.05-1.25,1.87-1.25h4.04v-6.06c0-1.12.9-2.02,2.02-2.02s2.02.9,2.02,2.02v6.06h4.04c.82,0,1.55.49,1.87,1.25.31.76.14,1.62-.44,2.2l-6.06,6.06c-.79.79-2.07.79-2.86,0l-6.06-6.06c-.58-.58-.75-1.45-.44-2.2Z",
    fill: "#4a46ab"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.41 26.33 60.33 35.24 51.41 35.24 51.41 26.33",
    fill: "#4a46ab"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfBene3Cp);
export default __webpack_public_path__ + "static/media/INF-Bene3-CP.e1dd162e80353dceea77a5763befb53c.svg";
export { ForwardRef as ReactComponent };